import { c as _c } from "react/compiler-runtime";
import useElementSize from '@/hooks/useElementSize';
import useElementHeight from '@/hooks/useElementSize/useElementHeight';
import { useLayoutEffect, useState } from 'react';
import FullText from './FullText';
import LimitedTextContent from './LimitedTextContent';
import MaxRows from './MaxRows';
const LimitedText = (t0) => {
    const $ = _c(51);
    const { text, maxRows: t1, noSeeMoreButton: t2, btnClassName: t3, withSeeLessButton: t4 } = t0;
    const maxRows = t1 === undefined ? 1 : t1;
    const noSeeMoreButton = t2 === undefined ? false : t2;
    const btnClassName = t3 === undefined ? "" : t3;
    const withSeeLessButton = t4 === undefined ? false : t4;
    const [seeMore, setSeeMore] = useState(false);
    const [isResetting, setIsResetting] = useState(false);
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = () => {
            setSeeMore(_temp);
        };
        $[0] = t5;
    }
    else {
        t5 = $[0];
    }
    const toggleSeeMore = t5;
    const [maxRowsSpan, setMaxRowsSpan] = useState(null);
    let t6;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (node) => {
            if (node) {
                setMaxRowsSpan(node);
            }
        };
        $[1] = t6;
    }
    else {
        t6 = $[1];
    }
    const maxRowsSpanRefCb = t6;
    const maxRowsSpanHeight = useElementHeight(maxRowsSpan);
    const [fullTextSpan, setFullTextSpan] = useState(null);
    let t7;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (node_0) => {
            if (node_0) {
                setFullTextSpan(node_0);
            }
        };
        $[2] = t7;
    }
    else {
        t7 = $[2];
    }
    const fullTextSpanRefCb = t7;
    const { height: fullTextSpanHeight, width: fullTextSpanWidth } = useElementSize(fullTextSpan);
    const [limitedTextSpan, setLimitedTextSpan] = useState(null);
    let t8;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (node_1) => {
            if (node_1) {
                setLimitedTextSpan(node_1);
            }
        };
        $[3] = t8;
    }
    else {
        t8 = $[3];
    }
    const limitedTextSpanRefCb = t8;
    const limitedTextSpanHeight = useElementHeight(limitedTextSpan);
    const rowHeight = maxRowsSpanHeight / maxRows;
    const hasMore = fullTextSpanHeight > maxRowsSpanHeight + Math.max(rowHeight * 0.75, 5);
    const fullTextRows = fullTextSpanHeight / rowHeight;
    const fullTextWords = text.split(" ");
    const approxWordPerRow = Math.floor(fullTextWords.length / fullTextRows);
    const isLimitedReady = !isResetting && limitedTextSpanHeight <= maxRowsSpanHeight;
    const [limitedText, setLimitedText] = useState(null);
    const [previousLimitedText, setPreviousLimitedText] = useState(null);
    let t9;
    if ($[4] !== approxWordPerRow || $[5] !== maxRows || $[6] !== rowHeight) {
        t9 = (limitedTextSpanHeight_0) => {
            const rowDiff = Math.round(limitedTextSpanHeight_0 / rowHeight) - maxRows;
            if (rowDiff > 0) {
                let wordsToRemove = 1;
                if (rowDiff > 2) {
                    wordsToRemove = Math.floor(approxWordPerRow * (rowDiff - 2));
                }
                else {
                    if (rowDiff === 2) {
                        wordsToRemove = Math.max(Math.floor(approxWordPerRow / 2), 1);
                    }
                }
                setLimitedText((c_0) => {
                    const words = c_0.split(" ");
                    words.splice(-wordsToRemove);
                    return (words.join(" "));
                });
            }
        };
        $[4] = approxWordPerRow;
        $[5] = maxRows;
        $[6] = rowHeight;
        $[7] = t9;
    }
    else {
        t9 = $[7];
    }
    const removeWords = t9;
    let t10;
    if ($[8] !== fullTextSpanWidth || $[9] !== isResetting || $[10] !== limitedText || $[11] !== limitedTextSpan || $[12] !== previousLimitedText || $[13] !== removeWords) {
        t10 = () => {
            if (fullTextSpanWidth &&
                limitedTextSpan && !!limitedText && (limitedText !== previousLimitedText || isResetting)) {
                setIsResetting(false);
                setPreviousLimitedText(limitedText);
                removeWords(limitedTextSpan.clientHeight);
            }
        };
        $[8] = fullTextSpanWidth;
        $[9] = isResetting;
        $[10] = limitedText;
        $[11] = limitedTextSpan;
        $[12] = previousLimitedText;
        $[13] = removeWords;
        $[14] = t10;
    }
    else {
        t10 = $[14];
    }
    let t11;
    if ($[15] !== fullTextSpanWidth || $[16] !== isResetting || $[17] !== limitedText || $[18] !== limitedTextSpan || $[19] !== maxRows || $[20] !== previousLimitedText || $[21] !== removeWords || $[22] !== text) {
        t11 = [
            isResetting,
            removeWords,
            limitedText,
            previousLimitedText,
            limitedTextSpan,
            fullTextSpanWidth,
            maxRows,
            text
        ];
        $[15] = fullTextSpanWidth;
        $[16] = isResetting;
        $[17] = limitedText;
        $[18] = limitedTextSpan;
        $[19] = maxRows;
        $[20] = previousLimitedText;
        $[21] = removeWords;
        $[22] = text;
        $[23] = t11;
    }
    else {
        t11 = $[23];
    }
    useLayoutEffect(t10, t11);
    let t12;
    if ($[24] !== fullTextSpanWidth || $[25] !== text) {
        t12 = () => {
            if (fullTextSpanWidth) {
                setTimeout(() => {
                    setLimitedText(text);
                    setIsResetting(true);
                }, 300);
            }
        };
        $[24] = fullTextSpanWidth;
        $[25] = text;
        $[26] = t12;
    }
    else {
        t12 = $[26];
    }
    let t13;
    if ($[27] !== fullTextSpanWidth || $[28] !== maxRows || $[29] !== text) {
        t13 = [text, maxRows, fullTextSpanWidth];
        $[27] = fullTextSpanWidth;
        $[28] = maxRows;
        $[29] = text;
        $[30] = t13;
    }
    else {
        t13 = $[30];
    }
    useLayoutEffect(t12, t13);
    const computedBtnClassName = `btn-ghost-primary -my-1.5 -ml-2 ${btnClassName}`;
    let t14;
    if ($[31] !== computedBtnClassName || $[32] !== hasMore || $[33] !== seeMore || $[34] !== text || $[35] !== withSeeLessButton) {
        t14 = <FullText ref={fullTextSpanRefCb} btnClassName={computedBtnClassName} toggleSeeMore={toggleSeeMore} text={text} withSeeLessButton={withSeeLessButton} hasMore={hasMore} seeMore={seeMore}/>;
        $[31] = computedBtnClassName;
        $[32] = hasMore;
        $[33] = seeMore;
        $[34] = text;
        $[35] = withSeeLessButton;
        $[36] = t14;
    }
    else {
        t14 = $[36];
    }
    let t15;
    if ($[37] !== computedBtnClassName || $[38] !== hasMore || $[39] !== isLimitedReady || $[40] !== limitedText || $[41] !== noSeeMoreButton || $[42] !== seeMore) {
        t15 = <LimitedTextContent isReady={isLimitedReady} noSeeMoreButton={noSeeMoreButton} seeMore={seeMore} text={limitedText} hasMore={hasMore} btnClassName={computedBtnClassName} toggleSeeMore={toggleSeeMore} ref={limitedTextSpanRefCb}/>;
        $[37] = computedBtnClassName;
        $[38] = hasMore;
        $[39] = isLimitedReady;
        $[40] = limitedText;
        $[41] = noSeeMoreButton;
        $[42] = seeMore;
        $[43] = t15;
    }
    else {
        t15 = $[43];
    }
    const t16 = !isLimitedReady && !seeMore;
    let t17;
    if ($[44] !== maxRows || $[45] !== t16) {
        t17 = <MaxRows ref={maxRowsSpanRefCb} maxRows={maxRows} skeleton={t16}/>;
        $[44] = maxRows;
        $[45] = t16;
        $[46] = t17;
    }
    else {
        t17 = $[46];
    }
    let t18;
    if ($[47] !== t14 || $[48] !== t15 || $[49] !== t17) {
        t18 = <><span className="inline-block w-full relative">{t14}{t15}{t17}
      </span></>;
        $[47] = t14;
        $[48] = t15;
        $[49] = t17;
        $[50] = t18;
    }
    else {
        t18 = $[50];
    }
    return t18;
};
export default LimitedText;
function _temp(c) { return !c; }
